module.exports = __webpack_public_path__ + "img/second-block-bg.72df9324.jpg";